module.exports = __webpack_public_path__ + "static/assurance2-f3d10821ca2c049b131566a5e3a9b4ff.jpg";